import { Directive, HostListener } from '@angular/core';
import { LLFormService } from '../services/index';

@Directive({
  selector: '[appKeyupDirective]'
})
export class KeyUpDirective {

  value = '';
  keycodes: number[] = [8, 37, 39,46]; // backspace, left and right arrow, delete
  

  constructor (private llService: LLFormService) { }
  
  @HostListener('window:keyup', ['$event']) keyEvent(event: KeyboardEvent) {

    if (!this.keycodes.includes(event.keyCode)) {

      this.value += event.key;

      if (this.value.length >= 3) {

        // send to Api
        // this.llService.sendtoApi(value);

        console.log(this.value);
      }
    }
  }
}
